import { useEffect } from 'react';
import { Form, Modal, Upload } from 'antd';
import { useGetParentDocumentTypesQuery } from '@/services/general-api';
import { UploadSvg } from '@/assets/icons';
import Select from '@/components/select';
import Button from '@/components/button';
import { useUploadParentDocumentMutation } from '@/services/parent-api';

const UploadModal = ({ parentId, open, refetch, onClose }) => {
  const { data: typeData, isLoading: loadingTypeData } = useGetParentDocumentTypesQuery();
  const [uploadDocument, { isLoading: uploading }] = useUploadParentDocumentMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    const body = new FormData();
    body.append('file', values.document);

    let type;
    if (values.typeCode === "rtiq") {
      type = "response-to-initial-questions";
    } else if (values.typeCode === "vwf") {
      type = "voluntary-withdrawal-form";
    } else if (values.typeCode === "oq") {
      type = "orientation-quiz";
    } else {
      type = values.typeCode.slice(3);
    }

    console.log('tc:' + values.typeCode);
    console.log('t:'+ type);

    try {
      await uploadDocument({ parentId, type, body }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Upload Document"
      open={open}
      okText="Upload"
      confirmLoading={uploading}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="typeCode" label="Document Type" rules={[{ required: true }]}>
          <Select options={typeData} loading={loadingTypeData} valueName="code" />
        </Form.Item>
        <Form.Item
          name="document"
          label="Document"
          valuePropName="file"
          getValueFromEvent={(e) => e?.file}
          rules={[{ required: true, message: 'Please select document' }]}
        >
          <Upload beforeUpload={() => false} maxCount={1} showUploadList={{ showRemoveIcon: false }}>
            <Button icon={<UploadSvg />}>Select document file</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UploadModal;
